import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(${props => props.columns}, 1fr);
	grid-template-rows: repeat(${props => props.rows}, 1fr);
	gap: 2%;
	height: 100%;
`;

export const GridItem = styled.div`
	background: ${colors.white};
	border-radius: 15px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: center;
	padding: 3px 10px;
	width: 100%;
	height: 100%;
	// &:hover {
	// 	cursor: pointer;
	// 	transform: translateY(-5px);
	// 	transition: transform 0.3s ease, box-shadow 0.3s ease;
	// 	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
	// }
`;

export const GridWrapper = styled.div`
	display: grid;
	gap: 2%;
	height: 100%;
`;

export const IconContentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const KPIIconWrapper = styled.div`
	height: auto;
`;

export const InsightDetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-end;
`;

export const Value = styled.div`
	font-weight: bold;
	flex-grow: 1; /* Allow it to grow relative to the available space */
	text-align: right; /* Align to the right inside IconContentWrapper */
`;

export const Text = styled.div`
	font-weight: 400;
	text-align: right;
	color: ${({ isLight }) => (isLight ? colors.white : colors.black)};
`;
